// extracted by mini-css-extract-plugin
module.exports = {"categoryHolder":"blog-post-module--categoryHolder--Oc8dl","category":"blog-post-module--category--2N0W1"};